import styled from '@emotion/styled';
import { TableCell } from '@mui/material';

export const StyledCell = styled(TableCell)(() => ({
  borderRight: '1px solid lightGray',
  paddingTop: '8px',
  paddingBottom: '8px',
  minHeight: '50px',
  transition: 'background-color 0.2s ease',
  cursor: 'pointer',
  textDecoration: 'none',
  
  '&:hover': {
    backgroundColor: '#f0f8ff',
  },
}));
